import type { IOption } from "@src/components/ui-kit";
import type { WorkspaceStore } from "@src/stores/WorkspaceStore/WorkspaceStore";

export function workspaceCompanies(
  companies: WorkspaceStore["companies"],
): IOption[] {
  return companies.map((company) => ({
    value: company.id,
    label: company.internal_name,
    disabled: company.deleted,
  }));
}
